import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Card, Table, Alert } from 'react-bootstrap';
import axios from '../../axios/axiosconf';
import ModalDatosFacturacion from '../rips/ModalDatosFacturacion';

function CompletarDatosFactura({ show, facturaId, onComplete, onCancel }) {
    const [factura, setFactura] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Estados para el flujo de modales
    const [showModalDatosFacturacion, setShowModalDatosFacturacion] = useState(false);
    const [showModalEnvioDian, setShowModalEnvioDian] = useState(false);
    const [showModalEnviando, setShowModalEnviando] = useState(false);
    const [mensajeEnvio, setMensajeEnvio] = useState('');
    const [errorEnvio, setErrorEnvio] = useState(null);
    
    const [datosRips, setDatosRips] = useState(null);

    useEffect(() => {
        if (show && facturaId) {
            cargarFactura();
        }
    }, [show, facturaId]);

    useEffect(() => {
        if (!show) {
            setFactura(null);
            setDatosRips(null);
            setShowModalDatosFacturacion(false);
            setShowModalEnvioDian(false);
            setError(null);
        }
    }, [show]);

    const cargarFactura = async () => {
        try {
            setLoading(true);
            setError(null);
            
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const response = await axios.get(`/factura/${facturaId}?uid=${userdata.user_id}`);
            
            if (response.status === 200) {
                setFactura(response.data);

                // La API devuelve `detalle` (join lista_precios), no `items`
                const detalle = response.data.detalle || [];
                const row0 = detalle[0];
                const row1 = detalle[1];
                const codigo0 = row0?.lista_precio?.codigo || row0?.codigo || '';
                const codigo1 = row1?.lista_precio?.codigo || row1?.codigo || '';

                setDatosRips({
                    tipo_consulta: !!row0,
                    cupsc: codigo0,
                    valorconsulta: String(row0?.precio_unitario ?? '0'),
                    descuento_consulta: String(row0?.porcentaje ?? '0'),
                    impuesto_consulta: String(row0?.impuesto ?? '0'),
                    total_consulta: String(row0?.total ?? '0'),

                    tipo_procedimiento: !!row1,
                    cupsp: codigo1,
                    valorprocedimiento: String(row1?.precio_unitario ?? '0'),
                    descuento_procedimiento: String(row1?.porcentaje ?? '0'),
                    impuesto_procedimiento: String(row1?.impuesto ?? '0'),
                    total_procedimiento: String(row1?.total ?? '0'),

                    total_bruto: String(response.data.valor_bruto ?? '0'),
                    total_pagar: String(response.data.valor_total ?? '0')
                });

                setShowModalDatosFacturacion(true);
            }
        } catch (err) {
            console.error('Error cargando factura:', err);
            setError('Error al cargar los datos de la factura');
        } finally {
            setLoading(false);
        }
    };

    const handleConfirmarDatosFacturacion = async (datosCompletos) => {
        try {
            setShowModalDatosFacturacion(false);
            setError(null);

            const parametrosfevId = parseInt(datosCompletos.prefijo, 10);
            if (!parametrosfevId) {
                setError('Debe seleccionar un prefijo / resolución FEV.');
                setShowModalDatosFacturacion(true);
                return;
            }

            // Backend FacturaController::completarDatosFactura espera parametrosfev_id y forma_pago (código medio de pago, ej. 10)
            const datosActualizacion = {
                parametrosfev_id: parametrosfevId,
                forma_pago: String(datosCompletos.metodo_pago || '10'),
                valor_bruto: parseFloat(datosCompletos.total_bruto) || 0,
                valor_total: parseFloat(datosCompletos.total_pagar) || 0
            };

            const response = await axios.put(`/facturas/${facturaId}/completar-datos`, datosActualizacion);

            if (response.status === 200 && response.data?.success !== false) {
                setShowModalEnvioDian(true);
            } else {
                throw new Error(response.data?.message || 'Respuesta inesperada del servidor');
            }
        } catch (err) {
            console.error('Error completando datos:', err);
            let msg =
                err.response?.data?.message ||
                err.response?.data?.error ||
                err.message ||
                'Error al completar los datos de facturación';
            const ve = err.response?.data?.errors;
            if (ve && typeof ve === 'object') {
                msg = Object.values(ve).flat().join(' ') || msg;
            }
            setError(msg);
            alert(msg);
            setShowModalDatosFacturacion(true);
        }
    };
    
    const handleConfirmarEnvioDian = async () => {
        setShowModalEnvioDian(false);
        setShowModalEnviando(true);
        setMensajeEnvio('Enviando factura a la DIAN...');
        setErrorEnvio(null);
        
        try {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            const response = await axios.post(`/factura/${facturaId}/enviar-dian?uid=${userdata.user_id}`, {});
            
            if (response.data.success) {
                setMensajeEnvio(`✅ Factura enviada exitosamente a la DIAN\n\nCUFE: ${response.data.uuid || 'N/A'}`);
                setErrorEnvio(null);
            } else {
                setMensajeEnvio('Error al enviar a la DIAN');
                setErrorEnvio({
                    message: response.data.message || 'Error desconocido',
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code
                });
            }
        } catch (envioError) {
            console.error('Error enviando a DIAN:', envioError);
            setMensajeEnvio('Error al enviar a la DIAN');
            setErrorEnvio({
                message: envioError.response?.data?.message || envioError.message,
                status: envioError.response?.status,
                statusText: envioError.response?.statusText,
                data: envioError.response?.data,
                fullError: envioError.response || envioError
            });
        }
    };
    
    const handleCancelarEnvioDian = () => {
        setShowModalEnvioDian(false);
        // Cerrar todo y notificar éxito (factura completada pero no enviada)
        onComplete();
    };
    
    const handleCerrarModalEnviando = () => {
        setShowModalEnviando(false);
        // Cerrar todo y notificar éxito
        onComplete();
    };

    const formatearValor = (valor) => {
        return '$' + Math.round(parseFloat(valor || 0)).toLocaleString('es-CO');
    };

    if (loading) {
        return (
            <Modal show={show} onHide={onCancel} size="lg" centered>
                <Modal.Body className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Cargando...</span>
                    </div>
                    <p className="mt-3">Cargando datos de la factura...</p>
                </Modal.Body>
            </Modal>
        );
    }

    if (show && error && !factura) {
        return (
            <Modal show={show} onHide={onCancel} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert variant="danger" className="mb-0">{error}</Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onCancel}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    return (
        <>
            {/* Modal de Datos de Facturación */}
            {factura && datosRips && (
                <ModalDatosFacturacion
                    show={showModalDatosFacturacion}
                    onClose={() => {
                        setShowModalDatosFacturacion(false);
                        onCancel();
                    }}
                    onConfirm={handleConfirmarDatosFacturacion}
                    profesionalId={factura.users_id}
                    datosRips={datosRips}
                    filtroPrefijoRelajado={true}
                />
            )}
            
            {/* Modal de Confirmación de Envío a DIAN */}
            <Modal show={showModalEnvioDian} onHide={handleCancelarEnvioDian} centered>
                <Modal.Header closeButton className="border-0" style={{ background: '#f8f9fa' }}>
                    <Modal.Title className="text-dark font-weight-bold h6 mb-0">
                        <i className="fas fa-file-invoice mr-2 text-info"></i>
                        Factura Completada
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <div className="mb-3">
                        <i className="fas fa-file-invoice text-secondary" style={{ fontSize: '64px', opacity: 0.9 }}></i>
                    </div>
                    <h5 className="mb-3">¡Datos de facturación completados exitosamente!</h5>
                    <Alert variant="info" className="text-left">
                        <strong>Factura ID:</strong> {facturaId}<br />
                        <strong>Estado:</strong> Generada (lista para enviar a DIAN)
                    </Alert>
                    <p className="mb-0">¿Desea enviar esta factura a la DIAN ahora?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelarEnvioDian}>
                        <i className="fas fa-clock mr-1"></i>
                        No, enviar después
                    </Button>
                    <Button variant="primary" onClick={handleConfirmarEnvioDian}>
                        <i className="fas fa-paper-plane mr-1"></i>
                        Sí, enviar ahora
                    </Button>
                </Modal.Footer>
            </Modal>
            
            {/* Modal de Envío en Progreso / Resultado */}
            <Modal 
                show={showModalEnviando} 
                onHide={handleCerrarModalEnviando} 
                centered
                backdrop="static"
            >
                <Modal.Header
                    closeButton
                    className={`border-0 ${errorEnvio ? 'border-bottom border-danger' : ''}`}
                    style={{
                        background: '#f8f9fa',
                        ...(errorEnvio ? { borderBottomWidth: '3px', borderBottomStyle: 'solid' } : {})
                    }}
                >
                    <Modal.Title className="text-dark font-weight-bold h6 mb-0">
                        {mensajeEnvio.includes('Enviando') && !errorEnvio ? (
                            <><i className="fas fa-paper-plane mr-2 text-info"></i>Enviando a la DIAN</>
                        ) : errorEnvio ? (
                            <><i className="fas fa-exclamation-triangle mr-2 text-danger"></i>Error al Enviar a la DIAN</>
                        ) : (
                            <><i className="fas fa-check-circle mr-2 text-info"></i>Enviado Exitosamente</>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    {/* Icono dinámico según el estado */}
                    {mensajeEnvio.includes('Enviando') && !errorEnvio ? (
                        <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
                            <span className="sr-only">Enviando...</span>
                        </div>
                    ) : errorEnvio ? (
                        <i className="fas fa-times-circle text-danger mb-3" style={{ fontSize: '64px' }}></i>
                    ) : (
                        <i className="fas fa-check-circle text-info mb-3" style={{ fontSize: '64px' }}></i>
                    )}
                    
                    <h5 className="mb-3">{mensajeEnvio}</h5>
                    
                    {errorEnvio && (
                        <div className="text-left">
                            <Alert variant="danger">
                                <strong>Detalles del error:</strong>
                                <pre style={{ 
                                    maxHeight: '300px', 
                                    overflow: 'auto', 
                                    backgroundColor: '#f8f9fa',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    fontSize: '12px'
                                }}>
                                    {JSON.stringify(errorEnvio, null, 2)}
                                </pre>
                            </Alert>
                            <Alert variant="info">
                                <strong>Sugerencias:</strong>
                                <ul className="mb-0 mt-2">
                                    <li>Verifique que los parámetros de facturación electrónica estén configurados correctamente</li>
                                    <li>Revise que el prefijo seleccionado esté habilitado</li>
                                    <li>Verifique la conexión con el servidor de la DIAN</li>
                                    <li>Puede reintentar el envío desde el listado de facturas</li>
                                </ul>
                            </Alert>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCerrarModalEnviando}>
                        <i className="fas fa-check mr-1"></i>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default CompletarDatosFactura;
